import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate, { Validator } from 'vee-validate';
import ru from './assets/dictonary/ru/';
import 'normalize.css';
import moment from 'moment';

// import $ from 'jquery';
// import 'suggestions-jquery';
import decimal from "@/helpers/decimal";
decimal();

Vue.use(VeeValidate, {
    locale: 'ru'
});

Validator.localize('ru', ru);

Vue.config.productionTip = false

Validator.extend('yearsMin3', {
    getMessage: 'Не менее 3 лет',
    validate: value => {
        let target = moment()
          .subtract(3, 'year')
          .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue < target;
    }
});

Validator.extend('yearsMin18', {
    getMessage: 'Не менее 18 лет',
    validate: value => {
        let target = moment()
            .subtract(18, 'year')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue < target;
    }
});

Validator.extend('notPast', {
    getMessage: 'Не раньше следующего дня',
    validate: value => {
        let target = moment()
            // .subtract(0, 'day')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});
Validator.extend('dayMax60', {
    getMessage: 'Не более 60 дней',
    validate: value => {
        let target = moment()
            .add(60, 'day')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue < target;
    }
});

Validator.extend('yearsMax99', {
    getMessage: 'Не более 99 лет',
    validate: value => {
        let target = moment()
            .subtract(99, 'year')
            .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});

Validator.extend('yearsMax65', {
    getMessage: 'Не более 65 лет',
    validate: value => {
        let target = moment()
          .subtract(65, 'year')
          .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});

Validator.extend('yearsMax55', {
    getMessage: 'Не более 55 лет',
    validate: value => {
        let target = moment()
          .subtract(55, 'year')
          .toDate();
        let formatedValue = moment(value, 'DD.MM.YYYY', true).toDate();
        return formatedValue > target;
    }
});

Vue.filter('numeric',(value) => {
    return (value || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

